<script setup lang="ts">
import type { SelectScrollUpButtonProps } from "reka-ui"
import { SelectScrollUpButton } from "reka-ui"
import { ChevronUpIcon } from "lucide-vue-next"

const props = defineProps<SelectScrollUpButtonProps>()
</script>

<template>
  <SelectScrollUpButton v-bind="props" class="flex cursor-default items-center justify-center py-1">
    <ChevronUpIcon class="size-4" />
  </SelectScrollUpButton>
</template>
